import React from 'react';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { ButtonV2, StageChip } from 'components/common/ui';
import { ModalFooter, ModalV2 } from 'components/common/modals';

import styles from './multiSelectDeleteModal.style';

const MultiSelectDeleteModal = ({
  title = '',
  itemTitle = '',
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalV2
      id={`delete-${title}`}
      title={`Delete ${title}`}
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="xs"
    >
      Are you sure you want to delete the {`${title}:`}
      <Box sx={{ display: 'flex', justifyContent: 'start' }}>
        <StageChip
          styles={{
            backgroundColor: (theme) => theme.palette.grays.gray200,
            color: (theme) => theme.palette.grays.gray900,
          }}
        >
          {' '}
          {`${itemTitle}`}
        </StageChip>
        ?
      </Box>
      <ModalFooter>
        <ButtonV2 size="small" variant="text" onClick={onConfirm}>
          <DeleteIcon data-testid="DeleteIcon" sx={styles.deleteIcon} />
          <Box
            component="span"
            sx={{
              ...styles.modalButtonsText,
              color: (theme) => theme.palette.reds.codingRed400,
              '&:hover': {
                color: (theme) => theme.palette.reds.codingRed600,
              },
            }}
          >
            Delete
          </Box>
        </ButtonV2>
        <ButtonV2 variant="text" onClick={onClose}>
          <Box component="span" sx={styles.modalButtonsText}>
            Cancel
          </Box>
        </ButtonV2>
      </ModalFooter>
    </ModalV2>
  );
};

export default MultiSelectDeleteModal;
